<template>
  <div class="form-row">
    <div class="col-md-1 mb-3 align-self-center">
      <span>{{ $t("models.lop.title") }} {{ lop }}</span>
    </div>
    <div class="col-md-3 mb-3">
      <label :for="`ddlLop${lop}_MaTinh`">
        {{ $t("models.tinh.maTinh") }}: {{ $t("models.tinh.tenTinh") }}
      </label>

      <validation-provider
        rules="required"
        :name="$t('models.lop.maTinhLop', { lop: lop })"
        v-slot="{ errors, valid }"
      >
        <v-autocomplete
          :id="`ddlLop${lop}_MaTinh`"
          required
          :items="tinhs"
          :label="`${$t('models.tinh.maTinh')}: ${$t('models.tinh.tenTinh')}`"
          :item-value="(item) => item.maTinh"
          :item-text="(item) => `${item.maTinh}: ${item.tenTinh} `"
          outlined
          dense
          :success="valid === true"
          :is-valid="!!tinhId"
          :append-icon="
            valid ? 'mdi-check' : errors[0] ? 'mdi-alert-circle' : ''
          "
          :error="errors[0] ? true : false"
          :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
          v-model="tinhId"
          @change="getTruongs"
        ></v-autocomplete>

        <span class="text-danger">{{ errors[0] }}</span>
      </validation-provider>
    </div>
    <div class="col-md-8 mb-3">
      <label :for="`ddlLop${lop}_MaTruong`">
        {{ $t("models.truong.maTruong") }}: {{ $t("models.truong.tenTruong") }}
      </label>
      <validation-provider
        rules="required"
        :name="$t('models.lop.maTruongLop', { lop: lop })"
        v-slot="{ errors, valid }"
      >
        <v-autocomplete
          :id="`ddlLop${lop}_MaTruong`"
          :items="truong"
          required
          :label="$t('models.truong.select')"
          :item-value="(item) => item.truongId"
          :item-text="
            (item) =>
              `${item.maTruong}: ${item.tenTruong} - ${item.diaChiTruong}`
          "
          outlined
          dense
          :success="valid === true"
          :is-valid="!!truongId"
          :append-icon="
            valid ? 'mdi-check' : errors[0] ? 'mdi-alert-circle' : ''
          "
          :error="errors[0] ? true : false"
          :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
          v-model="truongId"
          @change="updateMaTruong"
        ></v-autocomplete>

        <span class="text-danger">{{ errors[0] }}</span>
      </validation-provider>
    </div>
  </div>
</template>

<script>
import ThongTinTHPT from "../js/thongtinthpt";
export default ThongTinTHPT;
</script>

<style lang="scss" scoped></style>
